import { render, staticRenderFns } from "./TicketEscalationComments.vue?vue&type=template&id=52417e68&"
import script from "./TicketEscalationComments.vue?vue&type=script&lang=ts&"
export * from "./TicketEscalationComments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports